/* src/app/views/dashboard/components/sidebar-nav/side-nav-header/side-nav-header.component.scss */
.side-nav-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.side-nav-header .nav-logo {
  height: 2.3125rem;
  cursor: pointer;
}
.side-nav-header svg {
  cursor: pointer;
}
/*# sourceMappingURL=side-nav-header.component.css.map */
